import { Component, Input, OnInit } from '@angular/core';

import { ChipListItem } from '../shared.interface';
import { DataService } from '../../e-met/services/data.service';


@Component({
    selector: 'app-chip-list',
    templateUrl: './chip-list.component.html',
    styleUrls: ['./chip-list.component.scss'],
})
export class ChipListComponent implements OnInit {
    @Input() chipListItems: ChipListItem[];

    constructor(
      private dataService: DataService,
    ) {}

    transferType$ = this.dataService.getTranferTypeTextKey('typeSingular1');
    ngOnInit(): void {}

}
